export const ConstVariables = {
  BLOG_POST: "Blog Posts",

  SHORTS_POST: "shorts",

  CHAT_ROOM_TOPIC: "chat_room_topic_v1",

  DIVINE_BLOGS_TOPIC: "divine_blogs_topic_v1",

  DEVELOPERS_TOPIC: "developers_topic_v1",

  REVIEWS_TOPIC: "reviews_topic_v1",
  DUMMI_IMAGE: "https://imageref404.jpg",
  FAKEPOSTID: "hbr404",
  CHAT_ROOM_TITLE: "Chat ROOM",
  REVIEWS_TITLE: "Reviews",
  DIVINE_BLOGS_TITLE: "Divine Blogs",
  BLOG_WITH_VIDEO: "Divine Blogs Video",
  SHORT_VIDEOS: "Short videos",
  BLOG_COMMENTS: "Blog Comments",
  REPLY_BLOG_COMMENTS: "Re: Blog Comments",
  ALL_BOOKS: "All Books",
  AUDIO_BOOKS: "Audio Books",
  BIBLE_QUIZ: "Bible QUIZ",
  LIVE_VIDEO_TEXT: "Live",
  BLOG_COMMENTS_PATH: "blog comments",
  NOTIFICATION_TEST_PATH: process.env.REACT_APP_NOTIFICATIONPATH,
  VIEWS: "views",
  SHARES: "shares",
  EDIFIED_COUNT: "edified",
  COMMENT_COUNT: "comments",
  READS: "reads",
  BOOKMARKS: "bookmarks",
  RATE: "rate",
  STREAM: "stream",
  // AUTH_URL: process.env.REACT_APP_CONNECTERE_URL,
  //CONNECTERE_API: "http://localhost:8080", TODO: CHANGE TO PRODUCTION URL,
  CONNECTERE_API: process.env.REACT_APP_CONNECTERE_URL,
  TV_API_URL: process.env.REACT_APP_BOOKS_SERVER_URL,
  WEB_BOOKS_API_KEY: process.env.REACT_APP_WEB_BOOKS_API_KEY,
  UNKNOWN_ERROR:
    "Process interrupted (error code: hbr0x0100), Try again later or report issue to suport team",
  NO_SERVER_RESPONSE:
    "Process interrupted (error code: hbr0x0000), Try again later or report issue to suport team",
  SERVICE_UNAVAILABLE:
    "Service unavailable at the moment. Retry after a while. Report to support team if issue persist",
  MAIL_BODY_RESET_PASS:
    "Did you request to reset your password on hbrlite app,\n\nif yes enter the below verification code in the app to verify your request. Ignore this message if you haven't issued a request.",
  MAIL_TITLE_RESET_PASS: "Reset password - hbrlite",
  APP_BASE_URL: "https://horemowbookreaderlite.web.app",
};
